import { render, staticRenderFns } from "./MyFriends.vue?vue&type=template&id=49bcd4c1&scoped=true"
import script from "./MyFriends.vue?vue&type=script&lang=js"
export * from "./MyFriends.vue?vue&type=script&lang=js"
import style0 from "./MyFriends.vue?vue&type=style&index=0&id=49bcd4c1&prod&lang=scss&scoped=true"
import style1 from "./MyFriends.vue?vue&type=style&index=1&id=49bcd4c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bcd4c1",
  null
  
)

export default component.exports